import { render, staticRenderFns } from "./ot-navigation.vue?vue&type=template&id=51c32825&scoped=true&"
import script from "./ot-navigation.vue?vue&type=script&lang=ts&"
export * from "./ot-navigation.vue?vue&type=script&lang=ts&"
import style0 from "./ot-navigation.vue?vue&type=style&index=0&id=51c32825&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c32825",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VIcon,VMenu,VNavigationDrawer})
